import { render } from "./DownloadNotice.vue?vue&type=template&id=42c9991d&scoped=true"
import script from "./DownloadNotice.vue?vue&type=script&lang=js"
export * from "./DownloadNotice.vue?vue&type=script&lang=js"

import "./DownloadNotice.vue?vue&type=style&index=0&id=42c9991d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c9991d"]])

export default __exports__